module.exports = __webpack_public_path__ + "static/media/mahjong_88.playngo.7f05b27e.jpeg";